import { PusherService } from '../../../ng2/shared/services/pusher/pusher-service';
import { downgradeInjectable } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import * as angular from 'angular';
import { StudentGroupingsResolver } from 'Src/app/routes/main/route-resolvers/student-groupings-resolver';
import { ApiService } from 'Src/ng2/shared/services/api-service/api-service';
import { BackgroundJob } from 'Src/ng2/shared/services/background-job/background-job.service';
import { BatchEditService } from 'Src/ng2/shared/services/batch-edit-service/batch-edit-service';
import { DateHelpers } from 'Src/ng2/shared/services/date-helpers/date-helpers.service';
import { EventBus } from 'Src/ng2/shared/services/event-bus/event-bus';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImNote } from 'Src/ng2/shared/services/im-models/im-note.service';
import { ImNotification } from 'Src/ng2/shared/services/im-models/im-notification.service';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { ObjectCache } from 'Src/ng2/shared/services/object-cache/object-cache.service';
import { ObjectHash } from 'Src/ng2/shared/services/object-hash/object-hash.service';
import { ToggleService } from 'Src/ng2/shared/services/toggle/toggle.service';
import { UserInactivity } from 'Src/ng2/shared/services/user-inactivity/user-inactivity.service';
import { UtilitiesService } from 'Src/ng2/shared/services/utilities/utilities.service';
import { LocalStorageService } from 'Src/ng2/shared/services/web-storage/local-storage/local-storage.service';
import { SessionStorageService } from 'Src/ng2/shared/services/web-storage/session-storage/session-storage.service';
import { CsvExporterService } from '../../../ng2/shared/services/csv-exporter/csv-exporter.service';
import { ErrorToaster } from '../../../ng2/shared/services/error-toaster/error-toaster.service';
import { ImGapPlan } from '../../../ng2/shared/services/im-models/im-gap-plan';
import { NotificationMessageParser } from '../../../ng2/shared/services/notification-message-parser/notification-message-parser.service';
import { UserRolePermissionsForModelService } from '../../../ng2/shared/services/user-role-permissions-for-model/user-role-permissions-for-model.service';
import { CalculatedFieldsResolver } from '../../routes/main/route-resolvers/calculated-fields-resolver';
import { FlagsResolver } from '../../routes/main/route-resolvers/flags-resolver';
import { FocusResolver } from '../../routes/main/route-resolvers/focus-resolver';
import { MadLibOptionsResolver } from '../../routes/main/route-resolvers/mad-lib-options-resolver';
import { MadLibStateResolver } from '../../routes/main/route-resolvers/mad-lib-state-resolver';
import { MilestonesResolver } from '../../routes/main/route-resolvers/milestones-resolver';
import { RollupGroupingResolver } from '../../routes/main/route-resolvers/rollup-grouping-resolver';
import { StudentsResolver } from '../../routes/main/route-resolvers/students-resolver';
import { ToolsResolver } from '../../routes/main/route-resolvers/tools-resolver';
import { Auth } from './../../../ng2/shared/auth/auth.service';
import { AssignSupportModalService } from './../../../ng2/shared/modals/assign-support/assign-support-modal.service';
import { ModalsService } from './../../../ng2/shared/modals/modals.service';
import { ImStudent } from './../../../ng2/shared/services/im-models/im-student.service';
import { PrevStateService } from './../../../ng2/shared/services/prev-state/prev-state.service';
import { StudentFetchService } from './../../../ng2/shared/services/student-fetch/student-fetch.service';
import { StudentPanelPersistance } from './../../../ng2/shared/services/student-panel-persistance/student-panel-persistance.service';
import { SuccessToaster } from './../../../ng2/shared/services/success-toaster/success-toaster.service';
import { DashboardGraphDataResolver } from './../../routes/main/route-resolvers/dashboard-graph-data-resolver';
import { MadLibStoreStateResolver } from './../../routes/main/route-resolvers/mad-lib-store-resolver';
import { ProcessingUpdateResolver } from './../../routes/main/route-resolvers/processing-update-resolver';
import { SchoolResolver } from './../../routes/main/route-resolvers/school-resolver';
import { StudentListCurrentStudentResolver } from './../../routes/main/route-resolvers/single-student-view-current-student-resolver';
import { StudentListResolver } from './../../routes/main/route-resolvers/student-list-resolver';
import { StudentPathsResolver } from './../../routes/main/route-resolvers/student-paths-resolver';
import { StudentSupportsResolver } from './../../routes/main/route-resolvers/student-supports-resolver';
import { UserResolver } from './../../routes/main/route-resolvers/user-resolver';

export const downgradedServicesModule = angular
  .module('downgraded-services', [])
  .service('DateHelpers', downgradeInjectable(DateHelpers))
  .service('EventBus', downgradeInjectable(EventBus))
  .service('Auth', downgradeInjectable(Auth))
  .service('ToggleService', downgradeInjectable(ToggleService))
  .service('PrevStateService', downgradeInjectable(PrevStateService))
  .service('Store', downgradeInjectable(Store))
  .service('ImNote', downgradeInjectable(ImNote))
  .service('ImUser', downgradeInjectable(ImUser))
  .service('ImSchool', downgradeInjectable(ImSchool))
  .service('ImCourseDiff', downgradeInjectable(ImCourseDiff))
  .service('UtilitiesService', downgradeInjectable(UtilitiesService))
  .service('LocalStorageService', downgradeInjectable(LocalStorageService))
  .service('SessionStorageService', downgradeInjectable(SessionStorageService))
  .service('ApiService', downgradeInjectable(ApiService))
  .service('ImNotification', downgradeInjectable(ImNotification))
  .service('ModalsService', downgradeInjectable(ModalsService))
  .service('AssignSupportModalService', downgradeInjectable(AssignSupportModalService))
  .service('StudentFetchService', downgradeInjectable(StudentFetchService))
  .service('StudentPanelPersistance', downgradeInjectable(StudentPanelPersistance))
  .service('SuccessToaster', downgradeInjectable(SuccessToaster))
  .service('ImGapPlan', downgradeInjectable(ImGapPlan))
  .service('ImStudent', downgradeInjectable(ImStudent))
  .service('PusherService', downgradeInjectable(PusherService))
  .service('backgroundJob', downgradeInjectable(BackgroundJob))
  .service('CsvExporter', downgradeInjectable(CsvExporterService))
  .service('ObjectHash', downgradeInjectable(ObjectHash))
  .service('ObjectCache', downgradeInjectable(ObjectCache))
  .service('BatchEditService', downgradeInjectable(BatchEditService))
  // route resolvers
  .service('StudentListResolver', StudentListResolver)
  .service('StudentListCurrentStudentResolver', StudentListCurrentStudentResolver)
  .service('ProcessingUpdateResolver', ProcessingUpdateResolver)
  .service('CalculatedFieldsResolver', CalculatedFieldsResolver)
  .service('StudentsResolver', StudentsResolver)
  .service('FlagsResolver', FlagsResolver)
  .service('StudentSupportsResolver', StudentSupportsResolver)
  .service('MadLibResolver', MadLibOptionsResolver)
  .service('SchoolResolver', SchoolResolver)
  .service('UserResolver', UserResolver)
  .service('DashboardGraphDataResolver', DashboardGraphDataResolver)
  .service('MadLibStoreStateResolver', MadLibStoreStateResolver)
  .service('MadLibStateResolver', MadLibStateResolver)
  .service('StudentPathsResolver', StudentPathsResolver)
  .service('MilestoneResolver', MilestonesResolver)
  .service('ToolsResolver', ToolsResolver)
  .service('FocusResolver', FocusResolver)
  .service('RollupGroupingResolver', RollupGroupingResolver)
  .service('StudentGroupingsResolver', StudentGroupingsResolver)
  .service('NotificationMessageParser', downgradeInjectable(NotificationMessageParser))
  .service('ErrorToaster', downgradeInjectable(ErrorToaster))
  .service('UserInactivity', downgradeInjectable(UserInactivity))
  .service('UserRolePermissionsForModelService', downgradeInjectable(UserRolePermissionsForModelService)).name;
